import View from "../account/views/OrdersView";
import components from "./components.js";
components.define("js-yearFilterForm", View);